/**
 * The sentence a failed request may put on screen (spec §3.12, §5: errors speak the user's language,
 * calmly, and never print `err.message`, axios text or the backend's English).
 *
 * The API client (api/client.js `toApiError`) words the failures nobody can act on itself, in the
 * user's language, and marks them with `messageKey: 'shell.errors.*'` (offline, timed out, too many
 * requests, no permission, server unavailable). Those messages are shown as they are. Anything else
 * is the server's own English ("Internal server error", a validation line, "Request failed with
 * status code 500") or a raw JavaScript error: the caller's translated `fallback` is shown instead.
 *
 *   setError(errorText(err, t('courseOverview.tariffSaveError')));
 *
 * A message the CLIENT wrote itself (a thrown `new Error(t('...'))`) is not a server message: show it
 * by setting it directly instead of throwing it through here.
 *
 * `pages/teacher/apiError.js` and `pages/ClientDetail/clientUi.js` (`failureText`) carry the same rule
 * for their pages; new code imports this one.
 */
export function errorText(err, fallback) {
  return err && err.messageKey && err.message ? err.message : fallback;
}

export default errorText;
